import { AppState } from 'Store'
import { createSelector } from 'reselect'
import { ResponseCatalog, RequestParams, ShortDataModel } from 'Models'

const getAll = (state: AppState) => state.modules.select.data
const getRequestParams = (state: AppState) => state.modules.select.requestParams
const getDataByKey = createSelector(
	getAll,
	(_, key) => key,
	(all, key) => all?.[key] ?? new ResponseCatalog<ShortDataModel>()
)
const getParamsByKey = createSelector(
	getRequestParams,
	(_, key) => key,
	(all, key) => all?.[key] ?? new RequestParams()
)
const getDictByKey = createSelector(
	getAll,
	(_, key) => key,
	(all, key) => (Array.isArray(all?.[key]) ? all?.[key] : [])
)

export const selectSelectors = {
	getAll,
	getRequestParams,
	getDataByKey,
	getParamsByKey,
	getDictByKey,
}
